import type { FaireProductEntity } from "../../entity_types/product";

export const p_gvd5bndbgq: FaireProductEntity = {
  token: "p_gvd5bndbgq",
  type: "product",
  name: "Strawberry Tea Towel",
  brandToken: "b_zqgv7epztb",
  brandName: "Nice life",
  imageUrl:
    "https://cdn.faire.com/fastly/b442ee6e2f89982d94979c9e2a18b1581168ea8bbcd1745fa2f3ec7ffd4c2c69.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/37118621bea4cd224ab83552a0e8ecbe6d0816ea774c1d1c0f923ef5070d2e5e.jpeg",
    "https://cdn.faire.com/fastly/286148e14cb72252e0a19d9a5dd9a89a9d7269d6db8f19e5300076f94a38fc67.jpeg",
    "https://cdn.faire.com/fastly/b55bbed0ee558a18a8b609842db267e03d4fe814672bf03442b1ad2560bf20a8.jpeg",
    "https://cdn.faire.com/fastly/a6ef2d88a068efb3e3b4d4c6465a0dfc8647b2f981fdc5292cff880d26c3c7a9.jpeg",
  ],
  priceDollars: 10,
  description:
    "• 100% natural cotton flour sack tea towel\n• 19” by 19”\n• Screenprinted with water based ink\n• Each towel is individually screen printed and cured in my studio by hand - therefore please allow slight variance in detail as this is meant to enhance the beauty of a hand printed item by the artist.",
  tags: [],
  msrpDollars: 20,
  inStock: false,
  meta: {
    source: "api",
    importedAt: "2026-08-12T22:27:50.221Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
